export default function ServiceScope() {
  const genres = [
    { name: 'Action', icon: 'ri-sword-line' },
    { name: 'Adventure', icon: 'ri-compass-3-line' },
    { name: 'Strategy', icon: 'ri-brain-line' },
    { name: 'Puzzle', icon: 'ri-puzzle-line' },
    { name: 'RPG', icon: 'ri-shield-star-line' },
    { name: 'Sports', icon: 'ri-football-line' },
    { name: 'Racing', icon: 'ri-steering-2-line' },
    { name: 'Simulation', icon: 'ri-building-line' },
  ];

  return (
    <section className="py-16 md:py-32 px-4 md:px-8 bg-[#0d0d0f]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-3xl md:text-6xl font-bold text-white mb-4 md:mb-6 px-4">Games I Review</h2>
          <p className="text-base md:text-xl text-[#b8b8b8] max-w-2xl mx-auto px-4">
            All genres welcome (except horror). Mac games only.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {genres.map((genre, index) => (
            <div
              key={index}
              className="bg-[#1a1a1d] rounded-xl md:rounded-2xl p-6 md:p-10 text-center hover:shadow-[0_0_30px_rgba(57,255,20,0.3)] transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 bg-[#39ff14] rounded-full flex items-center justify-center mx-auto mb-3 md:mb-5">
                <i className={`${genre.icon} text-2xl md:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-white">{genre.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
